export default __webpack_public_path__ + "static/media/pepe-snacking.ca4d3a41.jpeg";